<template>
  <div id="past-alerts-table-container">
    <div class="pa-header">
      Other Alerts
    </div>
    <div class="pa-container">
      <v-data-table
        :headers="headers"
        :items="otherAlertsData"
        hide-default-footer
      >
        <template #item.type="{ item }">
          <td>
            <div class="row-container">
              <div :class="[getColor(item.status)]" />
              {{ item.type }}
            </div>
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import leadDetailMixin from '@shared/mixins/leadDetailMixin';

export default {
  name: 'OtherAlertsTable',
  mixins: [leadDetailMixin],
  data() {
    return {
      headers: [{
        text: 'Alert',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'type',
      }, {
        text: 'Zone',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'zone',
      }, {
        text: 'Status',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'status',
      }, {
        text: 'Date',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'startTime',
      }],
    };
  },
  methods: {
    getColor(status) {
      if (status === 'Watching') {
        return 'yellow-dot';
      }
      return 'red-dot';
    },
  },
};
</script>

<style lang="scss">

#past-alerts-table-container {
  display: flex;
  flex-direction: column;
  .pa-header {
    font-weight: 800;
    color: $N100;
    margin-bottom: 10px;
    font-size: 12pt;
  }
  .pa-container {
    position: relative;
    .v-data-table__wrapper {
      max-height: 400px;
      thead {
        tr {
          th {
            background-color: $N100;
            height: 30px;
            color: $WHITE;
            font-size: 6pt;
            font-weight: 500;
            text-transform: uppercase;
          }
        }
      }
      tbody {
        tr {
          td {
            height: 30px;
            font-size: 8px;
            border: 0;
          }
          &:nth-child(even) {
            background-color: $N5;
          }
        }
      }
    }
    .row-container {
      display: grid;
      grid-template-columns: auto 1fr;
      align-items: center;
      gap: 10px;
      .yellow-dot {
        height: 8px;
        width: 8px;
        background-color: $SUNSET100;
        border-radius: 50%;
      }
    }
  }
}
</style>
